import { Signal } from 'framework/utils/Signal';
import { getDistance } from 'framework/utils/math-utils';

export class PinchCatcher {
  public onPinch: Signal<number> = new Signal();
  public onPinchStarted: Signal<void> = new Signal();
  public onPinchStopped: Signal<void> = new Signal();

  private evCache: PointerEvent[] = [];
  private prevDiff: number = -1;

  constructor(targetElement: HTMLElement) {
    targetElement.addEventListener('pointerdown', this.pointerDownHandler, false);
    targetElement.addEventListener('pointermove', this.pointerMoveHandler, false);
    targetElement.addEventListener('pointerup', this.pointerUpHandler, false);
    targetElement.addEventListener('pointercancel', this.pointerUpHandler, false);
    targetElement.addEventListener('pointerout', this.pointerUpHandler, false);
    targetElement.addEventListener('pointerleave', this.pointerUpHandler, false);
  }

  private pointerDownHandler = (ev: PointerEvent): void => {
    this.evCache.push(ev);
    if (this.evCache.length >= 2) {
      this.onPinchStarted.dispatch();
    }
  };

  private pointerMoveHandler = (ev: PointerEvent): void => {
    // Find this event in the cache and update its record with this event
    for (let i = 0; i < this.evCache.length; i++) {
      if (ev.pointerId === this.evCache[i].pointerId) {
        this.evCache[i] = ev;
        break;
      }
    }

    // If two pointers are down, check for pinch gestures
    if (this.evCache.length === 2) {
      // Calculate the distance between the two pointers
      const curDiff = getDistance(
        { x: this.evCache[0].clientX, y: this.evCache[0].clientY },
        { x: this.evCache[1].clientX, y: this.evCache[1].clientY },
      );

      if (this.prevDiff > 0) {
        if (curDiff > this.prevDiff) {
          this.onPinch.dispatch(curDiff - this.prevDiff);
        }
        if (curDiff < this.prevDiff) {
          this.onPinch.dispatch(curDiff - this.prevDiff);
        }
      }

      // Cache the distance for the next move event
      this.prevDiff = curDiff;

      ev.preventDefault();
    }
  };

  private pointerUpHandler = (ev: PointerEvent): void => {
    this.evCache.splice(this.evCache.indexOf(ev), 1);
    // If the number of pointers down is less than two then reset diff tracker
    if (this.evCache.length < 2) {
      this.prevDiff = -1;
      this.onPinchStopped.dispatch();
    }
  };
}
